import { render, staticRenderFns } from "./MemberCenterAdminUserComment.vue?vue&type=template&id=44eebc89&scoped=true&lang=pug&"
import script from "./MemberCenterAdminUserComment.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminUserComment.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterAdminUserComment.vue?vue&type=style&index=0&id=44eebc89&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eebc89",
  null
  
)

export default component.exports